import { render, staticRenderFns } from "./ModalIconBanner.vue?vue&type=template&id=23b1bba8&scoped=true"
import script from "./ModalIconBanner.vue?vue&type=script&lang=js"
export * from "./ModalIconBanner.vue?vue&type=script&lang=js"
import style0 from "./ModalIconBanner.vue?vue&type=style&index=0&id=23b1bba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b1bba8",
  null
  
)

export default component.exports